import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        '&.MuiDataGrid-root .MuiDataGrid-columnsContainer': {
            border: 'none',
            borderBottom:'1px solid #e0e0e0'
        },
        '&.MuiDataGrid-root .MuiDataGrid-iconButtonContainer .MuiIconButton-label': {
            display: 'none',
        },
        '&.MuiDataGrid-root .MuiDataGrid-footerContainer':{
            minHeight:"0px"
        },
        '&.MuiDataGrid-root .MuiDataGrid-cell': {
            paddingTop:"5px"
        },
        '&.MuiDataGrid-root .row-highlight': {
            fontWeight:"600"
        },
        '&.MuiDataGrid-root .column-header-background': {
            backgroundColor:"none"
        },
        '&.MuiDataGrid-root .MuiDataGrid-window': {
            overflowX: "auto"
        },
        '&.MuiDataGrid-root .MuiDataGrid-toolbarContainer': {
            justifyContent: "flex-end"
        }
    },
    bgDisabled: {
        backgroundColor: '#eee !important',
    },
    accordionSummary: {
        flexDirection: 'row-reverse',
        alignItems: 'flex-start',
        marginLeft: '-10px'
    },
    declineSummary: {
        backgroundColor: '#f7f7f7',
        borderRadius: '4px',
        flexDirection: 'row-reverse',
        alignItems: 'flex-start',
    },
    accordionDetails:{
        padding: '0 1rem 1rem 1rem'
    },
    singleAccordionDetails:{
        padding: '0 2rem 1rem 1rem'
    },
    expanded: {minHeight: '0 !important'},
    disabled: {opacity: '0.75 !important'},
    content: {
        margin: '10px',
        '&$expanded': {
            margin: '10px'
        },
    },
    nestedContent: {
        '&$expanded': {
            margin: '10px 0 5px 5px'
        },
    },
    expandIcon: {
        transform: 'rotate(270deg)',
        '&$expanded': {
            transform: 'rotate(0deg)',
        },
    },
    declineExpand: {
        transform: 'rotate(270deg)',
        padding: '10px 2px',
        '&$expanded': {
            transform: 'rotate(0deg)',
        },
    },
    declineContent: {
        margin: '13px 10px',
        '&$expanded': {
            margin: '13px 10px 5px 10px'
        },
    },
    statusContent: {
        paddingTop: '0',
        paddingLeft: '3rem'
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto'
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    btn: {
        display:"none"
    },
}));

